import React from 'react'

export default class ImpersonationBar extends React.Component {
  render() {
    const isImpersonating = localStorage.getItem('groove-impersonating')

    if (!isImpersonating) return null

    return <div className="impersonation-bar">Impersonating</div>
  }
}
